<template>
  <div class="table_card" v-if="charged">
    <div class="table_card__head">
      <v-layout row wrap>
        <v-flex lg9>
          <p class="table_card__head--title">Editar locación</p>
            <v-breadcrumbs class="breadcums">
              <v-icon slot="divider">chevron_right</v-icon>
              <v-breadcrumbs-item
                @click="$router.push({name: 'location'})"
                class="breadcums__option"
              >
                Locaciones creadas
              </v-breadcrumbs-item>
              <v-breadcrumbs-item
                disabled
                class="breadcums__disable"
              >
                Editar locación
              </v-breadcrumbs-item>
            </v-breadcrumbs>
        </v-flex>
        <v-flex lg3 class="filter_options">
          <v-flex class="right mr-0">
            <button
              class="faccess_button px-5"
              :disabled="formIsInError ? true : false "
              @click="formIsInError ? '' : createSublocation()"
            >
              Crear Inmueble
            </button>
            <div class="px-1">

            </div>
            <button
              class="faccess_button px-5"
              :disabled="formIsInError ? true : false "
              @click="formIsInError ? '' : editLocation()"
            >
              Guardar
            </button>
          </v-flex>
        </v-flex>
      </v-layout>
    </div>
    <div class="table_card__info">
      <v-layout row wrap>
          <v-flex xs6>
            <!-- Fotos de la oferta -->
            <span class="table_card__info--label">Foto</span>
            <div class="trainers__form--photo_container">
              <label
                for="trainerPhoto"
                class="faccess_button buttom_shadow px-5">Examinar</label>
              <input
                id="trainerPhoto"
                type="file"
                @change="onFileChange"
                name="image">
              <p>{{ photo_name }}</p>
            </div>
            <v-flex xs12>
              <span class="table_card__info--label">Nombre</span>
              <input
                class="faccess_input"
                type="text"
                :style="location.attributes.name.length<=0?'border-bottom:2px solid red !important;background-color:#ef4b4b59':''"
                name="Name"
                placeholder="Nombre de la locación"
                v-model="location.attributes.name">
            </v-flex>
            <v-flex xs12>
              <span class="table_card__info--label">Descripción</span>
              <textarea
                class="faccess_textarea"
                v-model="location.attributes.description"
                name="Description"
                placeholder="Descripción"
              ></textarea>
            </v-flex>
            <v-flex xs12>
              <span class="table_card__info--label">Tipo de locación</span>
              <v-select
                label="Tipo de locación"
                v-bind:items="location_types"
                v-model="location.attributes.location_type"
                single-line
                bottom
                color="#1476FB"
                solo
              ></v-select>
            </v-flex>
            <v-flex xs12 v-if="location.attributes.location_type == 'Llave Permanente'">
              <span class="table_card__info--label">Reporte de accesos</span>
              <v-select
                label="Seleccione una opción"
                :items="access_report_options"
                v-model="location.attributes.access_report"
                single-line
                bottom
                color="#1476FB"
                solo
              ></v-select>
            </v-flex>
            <v-flex xs12>
              <span class="table_card__info--label">Teléfono</span>
              <input
                class="faccess_input"
                type="tel"
                name="Phone"
                placeholder="Numero de teléfono"
                v-model="location.attributes.telephone">
            </v-flex>

            <v-flex xs12>
              <span class="table_card__info--label">Correo electrónico</span>
              <input
                class="faccess_input"
                type="email"
                name="Email"
                placeholder="Correo electrónico"
                v-model="location.attributes.email"
              >
            </v-flex>
            <v-flex xs12 v-if="getCompany().access.virtual_guard">
              <span class="table_card__info--label">Tipo de Vigilante virtual</span>
              <v-select
                label="Seleccione una opción"
                :items="virtual_guard_options"
                v-model="location.attributes.virtual_guard_type"
                single-line
                bottom
                color="#1476FB"
                solo
              ></v-select>
            </v-flex>
            <v-flex xs12 v-if="getCompany().access.virtual_guard">
              <span class="table_card__info--label">Locación principal</span>
              <v-select
                label="Seleccione una opción"
                :items="locations"
                item-text="name"
                item-value="id"
                v-model="location.attributes.main_location"
                single-line
                bottom
                color="#1476FB"
                solo
              ></v-select>
            </v-flex>
            <v-flex xs12 v-if="getCompany().locations.associated_locations">
              <span class="table_card__info--label">Locaciones asociadas</span>
              <v-select
                    class="table_card__info--multiple_select"
                    label="Seleccione una o más locaciones"
                    :items="locations"
                    item-text="name"
                    item-value="id"
                    v-model="location.attributes.associated_doors"
                    color="#1476FB"
                    multiple
                    chips
                    solo
              ></v-select>
            </v-flex>
            <v-flex xs12 v-if="timeZoneList.length!=1">
              <span class="table_card__info--label">Zona horaria</span>
              <v-select
                label="Zona horaria"
                :items="timeZoneList"
                item-value="code"
                item-text="name"
                v-model="location.attributes.time_zone"
                :class="location.attributes.time_zone.length<=0?'data_card__err_time_zone':''"
                single-line
                bottom
                required
                color="#1476FB"
                solo
              ></v-select>
            </v-flex>
            <v-flex xs12 >
              <span class="table_card__info--label">País</span>
              <v-select
                label="Seleccione un país"
                :items="countriesList"
                v-model="location.attributes.country"
                single-line
                bottom
                @change="reviewTimeZone()"
                color="#1476FB"
                solo
              ></v-select>
            </v-flex>
            <v-flex xs12 v-if="timeZoneList.length!=1">
              <span class="table_card__info--label">Zona horaria</span>
              <v-select
                label="Zona horaria"
                :items="timeZoneList"
                item-value="code"
                item-text="name"
                v-model="location.attributes.time_zone"
                :class="location.attributes.time_zone.length<=0?'data_card__err_time_zone':''"
                single-line
                bottom
                required
                color="#1476FB"
                solo
              ></v-select>
            </v-flex>

            <v-flex xs12>
              <span class="table_card__info--label">Ciudad</span>
              <input
                class="faccess_input"
                type="text"
                name="City"
                placeholder="Ciudad"
                v-model="location.attributes.city"
              >
            </v-flex>
            <v-flex xs12>
              <span class="table_card__info--label">Dirección</span>
              <input
                class="faccess_input"
                type="text"
                name="Address"
                placeholder="Dirección de la locación"
                v-model="location.attributes.address"
              >
            </v-flex>
            <v-flex xs12>
              <span class="table_card__info--label">Latitud</span>
              <input
                class="faccess_input"
                type="text"
                name="Latitud"
                placeholder="Latitud"
                v-model="location.attributes.latitude"
              >
            </v-flex>
            <v-flex xs12>
              <span class="table_card__info--label">Longitud</span>
              <input
                class="faccess_input"
                type="text"
                name="Longitud"
                placeholder="Longitud"
                v-model="location.attributes.longitude"
              >
            </v-flex>
            <v-flex xs12>
              <v-switch
                class="data_card__switch"
                :label="'Abierto al público'"
                v-model="location.attributes.published"
                color="#1476FB"
              ></v-switch>
            </v-flex>
            <v-flex xs12 style="display:flex;max-width:130%; width:130% !important" >
              <v-flex xs6>
                <span class="table_card__info--label">Foto de horarios</span>
                <div class="trainers__form--photo_container">
                  <label
                    for="schedulePhoto"
                    class="faccess_button buttom_shadow px-5">Examinar</label>
                  <input
                    id="schedulePhoto"
                    type="file"
                    @change="onFileChange"
                    name="schedule">
                </div>
                <v-flex
                  xs12
                  v-if="schedule_url_change"
                  class="classes__image_container mb-4">
                  <div
                    class="data_card__import_img"
                    :style="{backgroundImage: 'url('+ schedule_url +')'}">
                  </div>
                </v-flex>
              </v-flex>
              <v-flex xs6>
                <span class="table_card__info--label">Foto del gerente de la sede</span>
                <div class="trainers__form--photo_container">
                  <label
                    for="managerPhoto"
                    class="faccess_button buttom_shadow px-5">Examinar</label>
                  <input
                    id="managerPhoto"
                    type="file"
                    @change="onFileChange"
                    name="manager">
                </div>
                <v-flex
                  xs12
                  v-if="manager_url_change"
                  class="classes__image_container mb-4">
                  <div
                    class="data_card__import_img"
                    :style="{backgroundImage: 'url('+ manager_url +')'}">
                  </div>
                </v-flex>
              </v-flex>
            </v-flex>

            <span class="table_card__info--label">Correo electrónico del gerente</span>
            <input
              class="faccess_input"
              type="email"
              name="Manager Email"
              placeholder="Correo electrónico del gerente"
              v-model="location.attributes.manager_email"
            >
            <v-flex xs12>
              <v-switch
                class="data_card__switch"
                :label="'Limitar numero de invitaciones'"
                v-model="invitations_limited"
                color="#1476FB"
              ></v-switch>
            </v-flex>
            <v-flex xs12
                v-show="invitations_limited"
            >
              <span class="table_card__info--label">Máximo de invitaciones diarias por persona</span>
              <div class="data_card__counter justified">
                <div class="justified__container">
                  <button
                    class="faccess_counter__button"
                    @click="location.attributes.invitations_max_uses>0 ? location.attributes.invitations_max_uses--:null"><img src="@/assets/img/icons/icono-menos.svg" /></button>
                    <input
                        class="faccess_counter__input"
                        type="number"
                        name="Name"
                        :value="location.attributes.invitations_max_uses"
                        readonly
                        @change="excelTitle = ''"
                      />
                  <button
                    class="faccess_counter__button"
                    @click="location.attributes.invitations_max_uses++"><img src="@/assets/img/icons/icono-mas.svg" /></button>
                </div>
              </div>
            </v-flex>
            <v-flex xs12 style="max-width:120%; width:120% !important;" >
              <v-layout row wrap>
                <v-flex xs12 lg6>
                  <v-switch
                    class="data_card__switch"
                    :label="`Usa huella para pin`"
                    color="#1476FB"
                    v-model="location.attributes.use_fingerprint"
                  ></v-switch>
                </v-flex>
                <v-flex xs12 lg6>
                  <v-switch
                    class="data_card__switch"
                    :label="`Abierto los domingos`"
                    v-model="works_on_sundays"
                    @change="changeMySundays()"
                    color="#1476FB"
                  ></v-switch>
                </v-flex>
                <v-flex xs12 lg6>
                  <v-switch
                    class="data_card__switch"
                    :label="`Abierto los festivos`"
                    v-model="works_on_holidays"
                    color="#1476FB"
                  ></v-switch>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12 style="display:flex;max-width:130%; width:130% !important; margin-top:50px;" v-if="fieldError.length>0" >
              <p style="color:red;font-size:15px">
              Complete para continuar: {{fieldError}}
              </p>
            </v-flex>
          </v-flex>
          <v-flex xs6 class="preview_item">
            <preview-location
              :location="location"
              :url="url"
            ></preview-location>
          </v-flex>
        </v-layout>
      <section v-if="!formIsInError||scheduleIsInError">
      <v-flex
        xs12
        style="display:flex; margin: 50px 3% 0px 3%;">
          <v-layout
              row wrap justify-space-between>
            <v-flex  v-for="day in days"
              :key="day.name"
              v-if="(day.name!='sunday'|| works_on_sundays) &&day.name!=''&&day.name!=undefined"
              class="data_card__headers--days"
              :style="day.name==actual_day?
              !scheduleIsInError?'margin-top:-12px !important;background:#5a6b8e':'margin-top:-12px !important;background:#5a6b8e;cursor:not-allowed;' :
              !scheduleIsInError?'': 'cursor:not-allowed;'"
              @click="!scheduleIsInError?actual_day=day.name:''">
              <span class="data_card__info--label"
                    :style="day.name==actual_day?'font-weight:600;color:#F9FBFD':''">
                    {{ day.name_esp | capitalize }}
              </span>
            </v-flex>
          </v-layout>
      </v-flex>
      <v-flex
        xs12
        style="display:flex; margin: 0px 3% 0px 3%;">
          <v-layout
              row wrap justify-space-between>
            <v-flex  v-for="day in days"
              :key="day.name"
              v-if="(day.name!='sunday'|| works_on_sundays) &&day.name!=''&&day.name!=undefined"
              class="data_card__headers--days--transparency"
              :style="day.name==actual_day?
              !scheduleIsInError?'margin-top:-12px !important; background:none':'margin-top:-12px !important;background:#FFF;cursor:not-allowed;' :
              !scheduleIsInError?'': 'cursor:not-allowed;'"
              @click="!scheduleIsInError?actual_day=day.name:''">
            </v-flex>
          </v-layout>
      </v-flex>


      <section class="trainers__create_container data_card__headers--days--panel" >
        <v-layout row wrap>
          <v-flex xs12>
            <v-flex
              xs12 >
              <v-layout row wrap style="justify-content:space-evenly">
                <v-flex xs3>
                  <span class="table_card__info--label">Apertura</span>
                  <vue-timepicker class="data_card__info--select--time"
                      style="margin-left:0 !important"
                      format="hh:mm a"
                      placeholder="Apertura"
                      :minute-interval="5"
                      auto-scroll
                      input-width="95%"
                      v-model="timeBoxes[actual_day].begin"
                      @input="checkOpening()"
                      hour-label="Horas" minute-label="mins" apm-label="AM/PM"
                      close-on-complete
                      hide-clear-button></vue-timepicker>
                </v-flex>
                <v-flex xs3>
                  <span class="table_card__info--label">Cierre</span>
                  <vue-timepicker class="data_card__info--select--time"
                      style="margin-left:0 !important;"
                      format="hh:mm a"
                      placeholder="Cierre"
                      :minute-interval="5"
                      :minute-range="[endMinutesRange]"
                      :hour-range="[endRange]"
                      auto-scroll
                      input-width="95%"
                      v-model="timeBoxes[actual_day].end"
                      close-on-complete
                      @change="checkEnding()"
                      hour-label="Horas" minute-label="mins" apm-label="AM/PM"
                      hide-clear-button></vue-timepicker>
                </v-flex>

                <v-flex xs1 v-if="days[actual_day].original_time_zone_active">
                  <span class="table_card__info--label">Cierre al otro día</span>
                  <v-checkbox
                      v-model="days[actual_day].time_zone_active"
                      @change="checkEnding()"
                      color="#009CDE"
                      hide-details
                  ></v-checkbox>
                </v-flex>
                <v-flex xs1 v-if="days[actual_day].original_time_zone_active">
                </v-flex>

                <v-flex xs1>
                  <span class="table_card__info--label">Cupos</span>
                  <input
                    :class="!spacesInError?'data_card__info--input--number':'data_card__info--input--number--error'"
                    type="number"
                    name="nationality_code"
                    @keypress="isNumberValid($event)"
                    @blur="isFinalNumberValid($event,days[actual_day])"
                    v-model="days[actual_day].max_spaces"
                    @input="reviewSpaces()"
                  >
                </v-flex>

                <v-flex xs1>
                  <span class="table_card__info--label">Aforo</span>
                  <input
                    :class="!spacesInError?'data_card__info--input--number':'data_card__info--input--number--error'"
                    type="number"
                    name="nationality_code"
                    @keypress="isNumberValid($event)"
                    @blur="isFinalNumberValid($event,days[actual_day])"
                    v-model="days[actual_day].person_capacity"
                    @input="reviewSpaces()"
                  >
                </v-flex>
              </v-layout>
            </v-flex>
          </v-flex>
        </v-layout>
      </section>
      <p v-if="actualTimeZone.length>0"
        style="color:rgb(255, 134, 0);margin-top:20px;font-size:16px;font-weight:600;">
        Los horarios serán los correspondientes a la hora de {{actualTimeZone}}*
      </p>
      </section>
    </div>
    <div class="table_card__footer">
      <button
        class="faccess_button px-5"
        :disabled="formIsInError ? true : false "
        @click="formIsInError ? '' : editLocation()"
      >
        Guardar
      </button>
    </div>
  </div>
</template>
<script>
import VueTimepicker from 'vue2-timepicker/src/vue-timepicker.vue'
import CountriesInfo from '../../../vue/additionalData/countries.js'
import PreviewLocation from '../../shared/PreviewLocation.vue'
export default {
  data(){
    return{
      location_types: ['Reserva General', 'Llave Permanente', 'Reserva Sublocacion', 'Convenios', 'Paqueteria'],
      location: '',
      errorEnding:false,
      errorOpening:false,
      fieldError:'',
      charged: false,
      image_url: '',
      schedule_url: '',
      qr_text: '',
      photo_name: 'No se han seleccionado archivos',
      url_change: false,
      schedule_url_change: false,
      manager_url_change: false,
      manager_url: '',
      url:'https://s3-us-west-2.amazonaws.com/karrottsportlife/default_image.svg',
      actual_day:'monday',
      virtual_guard_options: ['Abierto', 'Privado'],
      access_report_options:['Accesos','Entradas y salidas'],
      days: {
        monday:     {name: 'monday',
                     begin:'',
                     end:'',
                     max_spaces:0,
                     type:'string',
                     name_esp: 'lunes',
                     begin_days:0,
                     end_days:0,
                     time_zone_active:false,
                     original_time_zone_active:false,
                     person_capacity:0
                    },
        tuesday:    {name: 'tuesday',
                     begin:'',
                     end:'',
                     max_spaces:0,
                     type:'string',
                     name_esp: 'martes',
                     begin_days:0,
                     end_days:0,
                     time_zone_active:false,
                     original_time_zone_active:false,
                     person_capacity:0
                    },
        wednesday:  {name: 'wednesday',
                     begin:'',
                     end:'',
                     max_spaces:0,
                     type:'string',
                     name_esp: 'miércoles',
                     begin_days:0,
                     end_days:0,
                     time_zone_active:false,
                     original_time_zone_active:false,
                     person_capacity:0
                    },
        thursday:   {name: 'thursday',
                     begin:'',
                     end:'',
                     max_spaces:0,
                     type:'string',
                     name_esp: 'jueves',
                     begin_days:0,
                     end_days:0,
                     time_zone_active:false,
                     original_time_zone_active:false,
                     person_capacity:0
                    },
        friday:     {name: 'friday',
                     begin:'',
                     end:'',
                     max_spaces:0,
                     type:'string',
                     name_esp: 'viernes',
                     begin_days:0,
                     end_days:0,
                     time_zone_active:false,
                     original_time_zone_active:false,
                     person_capacity:0
                    },
        saturday:   {name: 'saturday',
                     begin:'',
                     end:'',
                     max_spaces:0,
                     type:'string',
                     name_esp: 'sábado',
                     begin_days:0,
                     end_days:0,
                     time_zone_active:false,
                     original_time_zone_active:false,
                     person_capacity:0
                    },
        sunday:     {name: 'sunday',
                     begin:'',
                     end:'',
                     max_spaces:0,
                     type:'string',
                     name_esp: 'domingo',
                     begin_days:0,
                     end_days:0,
                     time_zone_active:false,
                     original_time_zone_active:false,
                     person_capacity:0
                   }
      },
      timeBoxes:{
        monday:     {
                     begin:"12:00 am",
                     end:"12:00 am"
                    },
        tuesday:    {
                     begin:"12:00 am",
                     end:"12:00 am"
                    },
        wednesday:  {
                     begin:"12:00 am",
                     end:"12:00 am"
                    },
        thursday:   {
                     begin:"12:00 am",
                     end:"12:00 am"
                    },
        friday:     {
                     begin:"12:00 am",
                     end:"12:00 am"
                    },
        saturday:   {
                     begin:"12:00 am",
                     end:"12:00 am"
                    },
        sunday:     {
                     begin:"12:00 am",
                     end:"12:00 am"
                    }
      },
      works_on_sundays: false,
      works_on_holidays: false,
      time: null,
      spacesInError:false,
      invitations_limited:false,
      locations:[]
    }
  },
  components: { VueTimepicker, PreviewLocation },
  watch:{
    schedule_url(){
      // cl schedule_url
      this.schedule_url_change = true;
    },
    manager_url(){
      // cl manager_url
      if(this.manager_url != ''){
        this.manager_url_change = true;
      }
    },
    invitations_limited(val){
      if (val==false){
        this.location.attributes.invitations_max_uses=null;
      }else if(this.location.attributes.invitations_max_uses==null){
        this.location.attributes.invitations_max_uses=0;
      }
    }
  },
  computed:{
    formIsInError(){
      var ans=false
      let fields=[]
      if(this.location.attributes.name.length==0){
        fields.push("'Nombre'");
      }
      if(this.location.attributes.country.length==0){
        fields.push("'País'")
      }
      if(this.location.attributes.time_zone.length==0){
        fields.push("'Zona Horaria'")
      }
      if(this.scheduleIsInError){
        fields.push("'Cronograma'")
      }
      if(fields.length>0){
        this.fieldError=fields.join(" y ")
        ans=true
      }else{
        this.fieldError=""
      }
      return ans
    },
    scheduleIsInError(){
      var ans=false
      if(this.errorOpening||this.errorEnding||this.spacesInError){
        ans=true
      }
      return ans
    },

    endRange(){
      var initialRange=0
      if(!this.days[this.actual_day].time_zone_active){
        initialRange=Number(this.convertDaytimeFormatToHour(this.timeBoxes[this.actual_day].begin).split(":")[0])
      }
      return [initialRange,23]
    },
    endMinutesRange(){

      let mins=[0,60]

      let myData= this.timeBoxes[this.actual_day]
      let arr=this.convertDaytimeFormatToHour(myData.end).split(":")
      let arr2=this.convertDaytimeFormatToHour(myData.begin).split(":")
      let end=Number(arr[0])

      if(end==Number(arr2[0])){
        mins=[Number(arr2[1]),mins[1]]
      }
      return mins;
    },
    countriesList(){
      return CountriesInfo.myCountries
    },
    timeZoneList(){
      return CountriesInfo.timeZones[this.location.attributes.country].time_zones
    },
    actualTimeZone(){
      let myZone=Intl.DateTimeFormat().resolvedOptions().timeZone;
      var ans=""
      var ct = require('countries-and-timezones');
      let timezone = ct.getTimezone(myZone);
      let timezone2 = ct.getTimezone(this.location.attributes.time_zone);
      if(timezone.utcOffset!=timezone2.utcOffset){
        ans=this.location.attributes.time_zone.split("/")[1].replace("_"," ") +", " + this.location.attributes.country + " ( GMT"+timezone2.utcOffsetStr+" )"
      }
      return  ans
    }
  },
  mounted(){

    this.getLocations()

    var path = this.$route.path.split('/')
    try {
      this.$http.get('locations/'+ path[2],)
      .then(function(response){
        console.log(response.body.data)
        this.invitations_limited= response.body.data.attributes.invitations_max_uses!==null && response.body.data.attributes.invitations_max_uses!==undefined  && response.body.data.attributes.invitations_max_uses >= 0;
        this.location = response.body.data
        this.location.attributes.associated_doors = this.location.attributes.associated_doors.map(id => (id).toString())
        this.image_url = this.location.attributes.image ? this.getImageServer() + this.location.attributes.image.url : ''
        this.schedule_url = this.location.attributes.schedule_image.url!=null ? this.getImageServer() + this.location.attributes.schedule_image.url : ''
        this.manager_url = this.location.attributes.manager_image.url!=null ? this.getImageServer() + this.location.attributes.manager_image.url : ''
        this.qr_text = this.location.id
        this.url = this.getImageServer() + this.location.attributes.image.url
        this.url_change = true
        if (response.body.included != null){
          var schedules = response.body.included.filter(object => object.type == 'location_schedules')[0].attributes
          this.works_on_sundays = schedules.works_on_sundays
          this.works_on_holidays = schedules.works_on_holidays
          // var new_schedules = schedules.map(object => object.beginning != null )
          var new_schedules = Object.entries(schedules)
          new_schedules = new_schedules.filter(object => object[1].beginning != null && object[1].ending != null )
          /* console.log(new_schedules); */
          var time_server=response.body.meta.time_zone
          for (var i = 0; i < new_schedules.length; i++) {
            this.days[new_schedules[i][0]].begin =
              new_schedules[i][1].beginning.hour < 10 ?
                '0' + new_schedules[i][1].beginning.hour + ':' +new_schedules[i][1].beginning.minute.toString().padStart(2,"0") :
                      new_schedules[i][1].beginning.hour + ':'+new_schedules[i][1].beginning.minute.toString().padStart(2,"0")
            this.days[new_schedules[i][0]].end =
              new_schedules[i][1].ending.hour < 10 ?
              '0' + new_schedules[i][1].ending.hour + ':' + new_schedules[i][1].ending.minute.toString().padStart(2,"0")   :
                    new_schedules[i][1].ending.hour + ':' + new_schedules[i][1].ending.minute.toString().padStart(2,"0");

            // this.days[new_schedules[i][0]].begin= this.convertToTimeZone(beg_hour_utc,time_server)
            // this.days[new_schedules[i][0]].end = this.convertToTimeZone(end_hour_utc,time_server)
            this.days[new_schedules[i][0]].max_spaces=new_schedules[i][1].max_spaces
            this.days[new_schedules[i][0]].begin_days=new_schedules[i][1].begin_days
            this.days[new_schedules[i][0]].end_days=new_schedules[i][1].end_days
            // Get capacity by day
            let day_name = this.days[new_schedules[i][0]].name
            let person_capacity = 0
            if(this.location.attributes.location_capacities != null && this.location.attributes.location_capacities.length > 0){
              this.location.attributes.location_capacities.map(function(value, key) {
                if (value[0] === day_name){
                  person_capacity = value[1]
                }
              });
            }

            this.days[new_schedules[i][0]].person_capacity=person_capacity

            // ||    this.days[new_schedules[i][0]].begin>this.convertToTimeZone(end_hour_utc,time_server)
            if(new_schedules[i][1].begin_days<new_schedules[i][1].end_days  ){
              this.days[new_schedules[i][0]].time_zone_active=true
              this.days[new_schedules[i][0]].original_time_zone_active=true
            }

            this.timeBoxes[new_schedules[i][0]].begin=this.convertHourToStyleFormat(this.days[new_schedules[i][0]].begin)
            this.timeBoxes[new_schedules[i][0]].end=this.convertHourToStyleFormat(this.days[new_schedules[i][0]].end)
          }
        }
        let arr=this.location.attributes.image.url.split("/")
        this.photo_name=arr[arr.length-1]
        this.charged = true
      }, function(response){
        if(response.body.meta != undefined && response.body.meta != null){
          if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
            this.checkToken(response.body.meta.authentication_token)
          }
        }
        if(typeof response.body.errors[0].details != "object"){
          alert(response.body.errors[0].details);
        }else{
          let message = []
          for(var key in response.body.errors[0].details){
            message.push(response.body.errors[0].details[key])
          }
          alert(message);
        }
      })
      } catch (e) {
        alert(e.message)
      }
  },
  methods:{

    getLocations(){

      console.log('location actual', this.$route.params.id)
      let params = { page: this.page }
      const data={company:{id:this.getCompany().id}}
      try {
        this.$http.post('locations/company',{data:this.encrypt(data).toString()},{
          headers:
          {"X-Device-ID" : this.getDeviceId(),
           "Authorization" : 'Bearer ' + this.getUserToken()},
           params
        })
        .then(function(response){


          response.body.data.forEach((element) => {

              var location = {
                  id: '',
                  name: ''
              }

              location.id=element.id
              location.name=element.attributes.name
                if(element.id !=  this.$route.params.id){
                  this.locations.push(location)
                }
              // console.log('element', element)
          });
          if(this.location.attributes.main_location != null){
            console.log('cargar locacion actual')
            var currectLocation = this.location.attributes.main_location
            this.location.attributes.main_location = this.locations.find(item => item.id == currectLocation);

          }

          // this.locations = response.body.data
          console.log('get locations',this.locations);


        })
      } catch (e) {
        alert(e.message)
      }
    },

    checkOpening(){
      let times=this.timeBoxes[this.actual_day]
      let begin= this.convertDaytimeFormatToHour(times.begin)
      if(begin.includes("NaN")){
        this.errorOpening=true;
      }else{
        this.errorOpening=false;
      }
      this.reviewTimes()
    },
    checkEnding(){
      let times=this.timeBoxes[this.actual_day]
      let end= this.convertDaytimeFormatToHour(times.end)
      if(end.includes("NaN")){
        this.errorEnding=true;
      }else{
        this.errorEnding=false;
      }

      this.reviewTimes()
    },
    reviewSpaces(){
      let data=this.days[this.actual_day]
      if(data.max_spaces<0){
        this.spacesInError=true;
      }else{
        this.spacesInError=false;
      }
      this.setNewSpaces();
    },
    reviewTimeZone(){
      if(this.timeZoneList.length==1){
        this.location.attributes.time_zone=this.timeZoneList[0].code
      }else{
        this.location.attributes.time_zone=''
      }
    },
    reviewTimes(){
      let times=this.timeBoxes[this.actual_day]
      var self= this
      var myData={}

      myData.begin= this.convertDaytimeFormatToHour(times.begin)
      myData.end= this.convertDaytimeFormatToHour(times.end)

      let beginArr=myData.begin.toString().split(":")
      let endArr=myData.end.toString().split(":")

      if(myData.begin.includes("NaN")){
        myData.begin= myData.begin.replace("NaN","00")
      }
      if(myData.end.includes("NaN")){
        myData.end= myData.end.replace("NaN","23")
      }

      // let daysCent=this.days[this.actual_day]
        // && daysCent.begin_days>=daysCent.end_days
      if(myData.begin>myData.end && !this.days[this.actual_day].time_zone_active ){
        myData.end=myData.begin
      }
      this.timeBoxes[this.actual_day].begin=this.convertHourToStyleFormat(myData.begin)
      this.timeBoxes[this.actual_day].end=this.convertHourToStyleFormat(myData.end)
      this.setNewSpaces()
    },
    checkSchedule () {
      var vm = this
      Object.keys(vm.days).forEach(function (key) {
        if (vm.days[key].begin == '' || vm.days[key].end == '') {
          delete vm.days[key]
        }
      });
    },
    isNumberValid(evt){
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            evt.preventDefault();;
        }else {
            return true;
        }
    },
    isFinalNumberValid(myData,day){
        if(myData.target.value.length==0){
          day.max_spaces=0;
        }else{
          if(day.max_spaces.toString()[0]=="0"&&day.max_spaces.length>0){
            day.max_spaces= Number(day.max_spaces.replace(/^0+/, ''));
          }
        }
    },
    setNewSpaces(){
      let data=this.timeBoxes[this.actual_day]
      var myData={};
      myData.begin= this.convertDaytimeFormatToHour(data.begin)
      myData.end= this.convertDaytimeFormatToHour(data.end)
      myData.max_spaces=this.days[this.actual_day].max_spaces
    },
    create_qr (){
      var qrcode = new QRCode(document.getElementById("qrcode"));
      qrcode.makeCode(this.location.id);
      this.qr = !this.qr;
      $("canvas").width("100%");
      $("canvas").css({"margin-left":"auto", "margin-right": "auto"});
    },
    onFileChange (e) {
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        return
      }
      var name_field = ""+e.target.name
      this[e.target.dataset.url] = URL.createObjectURL(files[0]);
      // this.url = URL.createObjectURL(files[0])
      if (name_field=='schedule') {
        this.schedule_url = URL.createObjectURL(files[0]);
      } else if(name_field=='manager'){
        this.manager_url = URL.createObjectURL(files[0]);
      } else {
        this.photo_name = files[0].name
        this.url = URL.createObjectURL(files[0]);
      }
      this.createImage(files[0],name_field)
    },
    createImage (file,name_field) {
      var reader = new FileReader()
      var vm = this;
      reader.readAsDataURL(file);
      reader.onload = function () {
        // cl name_field
        if(name_field=='image'){
          vm.location.attributes.image = reader.result
        }else if (name_field=='schedule') {
          vm.location.attributes.schedule_image = reader.result
        }else if(name_field=='manager'){
          vm.location.attributes.manager_image = reader.result
        }
      }
    },
    editLocation(){
      // this.checkSchedule()
      this.setDaysWithNewTimes();
      this.location.attributes.location_schedule_attributes = this.days
      this.$set(this.location.attributes.location_schedule_attributes, 'works_on_sundays', this.works_on_sundays)
      this.$set(this.location.attributes.location_schedule_attributes, 'works_on_holidays', this.works_on_holidays)
      this.location.attributes.title = this.location.attributes.name
      this.location.attributes.nationality_code=CountriesInfo.timeZones[this.location.attributes.country].indicative
      this.$delete(this.location.attributes, 'location_schedule')
      // cl location
      try {
        this.$http.patch('locations/'+ this.location.id, {data: this.encrypt(this.location).toString()},
          {headers:
            {"X-Device-ID" : this.getDeviceId(),
             "Authorization" : 'Bearer ' + this.getUserToken()},
        })
        .then(function(response){
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }

          if (this.location.attributes.is_trainer) {
            this.$router.push({name: 'classes_trainers'})
          }else{
            this.$router.push({name: 'location'})
          }

        }, function(response){
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
          if(typeof response.body.errors[0].details != "object"){
            // alert(response.body.errors[0].details);
            this.updateAlertMessage(response.body.errors[0].details);
            this.updateIsInAlert(true);
          }else{
            let message = []
            for(var key in response.body.errors[0].details){
              message.push(response.body.errors[0].details[key])
            }
            // alert(message);
            this.updateAlertMessage(message);
            this.updateIsInAlert(true);
          }
        })
      } catch (e) {
        // alert(e.message)
        this.updateAlertMessage(message);
        this.updateIsInAlert(true);
      }
    },
    convertToTimeZone(hour,time_zone){
      var offsetTime=new Date().getTimezoneOffset()
      let hours=Math.trunc(offsetTime/60) + Math.trunc(time_zone/3600)
      let minutes=(offsetTime%60) + ((time_zone%3600)/60)
      var arr=hour.split(":")

      let finalHour=Number(arr[0])-Number(hours)
      let finalMinutes=Number(arr[1])-Number(minutes)

      if(finalHour<0){
        finalHour= 24 + (finalHour%24)
      }

      if(finalMinutes<0){
        finalMinutes=60+(finalMinutes%60)
      }

      if(finalMinutes>=60){
        finalMinutes=finalMinutes%60
        finalHour=finalHour+(Math.trunc(finalMinutes/60))
      }
      if(finalHour>=24){
        finalHour=finalHour%24
      }


      return finalHour.toString().padStart(2,"0")+":"+finalMinutes.toString().padStart(2,"0");
    },
    convertHourToStyleFormat(hour){
      var arr=hour.split(":")
      var amOrPm="am"
      if(arr[0]>=12){
        amOrPm="pm"
        if(arr[0]>12){
          arr[0]= Number(arr[0])%12
        }
      }else if(arr[0]==0){
        arr[0]=12
      }
      if(Number(arr[0])<10){
        arr[0]="0"+Number(arr[0]).toString()
      }
      return arr[0]+":"+arr[1]+" "+amOrPm;
    },
    setDaysWithNewTimes(){
      var myConversion=function convertStyleFormatToHour(hour){
        var arr=hour.split(":")
        let hours=Number(arr[0])
        let secondArr=arr[1].split(" ")
        var minutes=secondArr[0]
        var amOrPm=secondArr[1]
        var finalHour=[hours,minutes]

        if(amOrPm=="pm" && hours!=12){
          finalHour[0]= (Number(hours)+12)%24
        }else if(hours==12 && amOrPm=="am" ){
          finalHour[0]=0
        }
        return finalHour[0].toString().padStart(2,"0")+":"+finalHour[1].toString().padStart(2,"0");
      }
      for(var key in this.timeBoxes){
        this.days[key].begin=myConversion(this.timeBoxes[key].begin);
        this.days[key].end=myConversion(this.timeBoxes[key].end);
      }
    },
    changeMySundays(){
      if(this.actual_day=='sunday'){
        if(this.spacesInError){
          this.days['sunday'].max_spaces=0
          this.reviewSpaces()
        }
        this.actual_day='monday'
      }
    },
    createSublocation(){
      this.$router.push({name:"new_sublocation_from_location", params: {id:this.$route.params.id}})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/locations/Edit_location.vue